import { Site } from '@envato/foundation-types'
import omit from 'lodash-es/omit'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import pushHistory from '../../../common/utils/location/pushHistory'

import { reportSearch } from '../../../common/analytics/searchBarAnalytics'
import {
  ILocationParams,
  IQuery
} from '../../../common/reducers/reactRouterLocation'
import { dearrayParamValues } from '../../../common/utils/location/format'
import redirectSearchIfItemId from '../../../common/utils/location/redirectSearchIfItemId'
import BasicForm from '../basicForm'

interface IProps extends React.FormHTMLAttributes<HTMLFormElement> {
  gaTrackingLabel?: string
  locationParams?: ILocationParams
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
}

const nextQuery = (
  locationParams: ILocationParams,
  query: IQuery
): ILocationParams => {
  // only update query inside the from and keep the existing one
  const newQuery = { ...locationParams, ...query }
  // remove page param when do search
  delete newQuery.page
  return dearrayParamValues(newQuery)
}

const SearchBarFormPure = (props: IProps & RouteComponentProps<any>) => {
  const {
    gaTrackingLabel = '',
    locationParams = {},
    makeSearchLink,
    history,
    children
  } = props
  const passProps = omit(props, [
    'locationParams',
    'makeSearchLink',
    'router',
    'onSubmit',
    'role',
    'method',
    'action',
    'match',
    'history',
    'staticContext',
    'nextQuery',
    'location',
    'gaTrackingLabel'
  ])

  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (gaTrackingLabel) {
      reportSearch(gaTrackingLabel)
    }

    // get query from form
    const form = event.currentTarget
    const query: { [propName: string]: string } = {}
    Array.prototype.slice
      .call(form.elements)
      .filter((el: HTMLInputElement) => el.getAttribute('name'))
      .forEach((el: HTMLInputElement) => {
        query[el.getAttribute('name') as string] = el.value
      })

    if (!redirectSearchIfItemId(query.term)) {
      pushHistory(history, makeSearchLink(nextQuery(locationParams, query)))
    }
  }

  return (
    <BasicForm
      role="search"
      method="get"
      action="/search"
      onSubmit={onSubmit}
      {...passProps}
    >
      {children}
    </BasicForm>
  )
}

export default withRouter(SearchBarFormPure)
